module.exports = __webpack_public_path__ + "static/media/left_active.e11648c1.svg";